import MainFrame from "../../../../components/mainFrame";
import { Box, Button, IconButton, TableRow } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../../../components/table";
import Navbar from "../../../../components/navbar";
import { Cell } from "../../../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../../../components/modal";
import { DeleteModal } from "../../../../components/appbar/modal";
import { smallButton } from "../../../../components/Button";
import { useLocation, useParams } from "react-router-dom";
import AddModal from "./modal";
import { Helmet } from "react-helmet";
import {
  useDeleteSnackPracticeMutation,
  useGetSnackPracticesQuery,
} from "../../../../app/services/practices.api";
import { SnackPractice } from "../../../../types/practice";
import { getLevelStr } from "../../../../utils/level";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function Practices() {
  const { setShow, setContent } = useModal();
  const params = useParams() as { snackId: string };
  const [deletePractice] = useDeleteSnackPracticeMutation();

  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      const practice = data?.entities[id] as SnackPractice;
      setContent({
        title: " ویرایش تمرین",
        body: <AddModal snackId={params.snackId} practice={practice} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن تمرین",
        body: <AddModal snackId={params.snackId} />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف تمرین",
        body: (
          <DeleteModal
            handleDelete={() => {
              deletePractice({ snackId: params.snackId, practiceId: id })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            }}
          />
        ),
      });
    }
    setShow(true);
  }

  const {
    state: { title: snackName = "" },
  } = useLocation() as { state: { title: string } };
  const { data, isLoading, isFetching } = useGetSnackPracticesQuery({
    snackId: params.snackId,
  });

  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> تمرین ها | پنل ادمین azno.school</title>
      </Helmet>
      <Navbar title={`تمرین های ${snackName} `}>
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن تمرین
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "عنوان" },
          { name: "سطح تمرین" },
          { name: "توضیحات" },
        ]}
        operations={true}
        length={0}
        isLoading={isLoading || isFetching}
      >
        {(data?.ids || []).map((id, index) => {
          const practice = data?.entities[id] as SnackPractice;

          return (
            <TableRow>
              <Cell>{index}</Cell>
              <Cell>{practice.title}</Cell>
              <Cell>{getLevelStr(practice.level)}</Cell>
              <Cell>{practice.desc}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handleOpenModal("edit", practice._id)}
                >
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton
                  onClick={() => handleOpenModal("delete", practice._id)}
                >
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Practices);
